import Big from "big.js";

export default class NumberUtils {

	static multiplyAndRound(value: number, multiplier: number, precision: number = 0): number {
		return Number(Number(value * multiplier).toFixed(precision))
	}

	static getNumberOfDecimals(value: number) {
		const decimalPart = value.toString().split(".")[1];
		if (decimalPart) {
			return decimalPart.length;
		}
		return 0;
	}

	static isNumber(value: string) {
		return value.match(/^[1-9\b]*[0-9\b]+$/) && !isNaN(Number(value))
	}

	static increaseByPercent(value: number, fraction: number) {
		return value + ((fraction / 100) * value);
	}

	static getValueBeforeIncreasingByPercent(value: number, fraction: number) {
		return value / (1 + fraction / 100);
	}

	/**
	 * Round any number to decimal format (max 2 decimal places, eg. 1.7777 => 1.78)
	 * @param {number} value
	 * @returns {number}
	 */
	static roundToMaxTwoDecimals(value: number) {
		return Math.round(value * 100) / 100;
	}
}

/**
 * Get given value as fraction (percentage). For instance markup 15 would return 0.15
 * @param value value to convert.
 * @return {number} given value divided by 100 and fixed to digits 4 after 0.
 */
export function getValueAsFraction(value: number): number {
	return Number(new Big(value).div(100).toFixed(4));
}

/**
 * Get value that was multiplied by given percentage.
 * For instance. func (3000, 20) = 2500 (3000 / (1 + 0.2))
 * @param value value value after applying percentage value.
 * @param percentage applied percentage.
 * @return value that was multiplied to get given value fixed to 2 digits after 0.
 */
export function getValueBeforePercentage(value: number, percentage: number): number {
	return Number(new Big(value).div(1 + getValueAsFraction(percentage)).toFixed(2));
}
